<form [formGroup]="deepFormGroup">
  <digires-state-indicator [formCtrlName]="fullFormCtrlName" [readOnly]="readOnly" [readOnlyReason]="readOnlyReason" [finModel]="finModel"></digires-state-indicator>
  <mat-form-field [ngClass]="{'changed':isDirty()}">
    <mat-label>{{placeholder}}</mat-label>
    <ng-container *ngIf="!multiSelect">
      <label >
        <input #input
          matInput type="text"
          formControlName="{{formCtrlName}}"
          [required]="required && !readOnly"
          [readonly]="readOnly"
          [matAutocomplete]='autocomplete'
          (change)="onInputChanged()"
          (input)="onFilterUsers($event)"
        >
      </label>

      <mat-autocomplete
        #autocomplete="matAutocomplete"
        [displayWith]="getUserName.bind(this)"
        (optionSelected)="onUserSelected($event.option.value)"
      >
        <mat-option *ngFor="let value of filteredUsers" [value]="value">
          {{value.fullName}}
        </mat-option>
      </mat-autocomplete>
    </ng-container>
    <ng-container *ngIf="multiSelect">
      <mat-select
        formControlName="{{formCtrlName}}"
        disableOptionCentering
        panelClass="mat-dropdown-panel-override"
        [required]="required && !readOnly"
        [multiple]="multiSelect"
        [disabled]="readOnly"
      >
        <mat-option *ngFor="let value of filteredUsers" [value]="value" matTooltip="{{value.fullName}}">
          {{value.fullName}}
        </mat-option>
      </mat-select>
    </ng-container>

    <mat-error *ngIf="error">
      {{error}}
    </mat-error>
    <mat-error *ngFor="let err of getErrorMessages()">
      {{err}}
    </mat-error>
  </mat-form-field>
  <mat-icon *ngIf="!!tooltip" class="tooltip-icon" matTooltipPosition="above" matTooltip="{{tooltip}}" svgIcon="tooltip"></mat-icon>
  <mat-icon *ngIf="!!finModel" class="warning-triangle" [class.transparent]="!finModel.hasUpload || !finModel.isReadable(fullFormCtrlName) || finModel.isRead(fullFormCtrlName)"
            matTooltip="Note: The value in this field was not populated by the most recent upload of the financial model">
    warning
  </mat-icon>
</form>
